/**
 * Privacy · Terms · SMS · Cookies · All legal, pinned bottom-centre (#768).
 *
 * These links used to live in the sidebar footer. In a long nav — a lead
 * TRFer sees seven groups — they were pushed below the fold, so the one
 * chrome element that must always be reachable was the one you had to scroll
 * a nav to find. Now they sit on the page, fixed, and do not move.
 *
 * GH-271.4 is still the reason Cookies and the /legal index are here at all:
 * both must be reachable by navigation, not only by typing the URL.
 *
 * Hidden below `md`. That is where the sidebar stops being pinned and parents
 * get a `BottomNav` — a fixed strip there would sit on top of the tab bar. The
 * links stay reachable on mobile through /legal and the footer of the public
 * pages.
 *
 * #2629: it is a row of the app shell's content column, under the scrolling
 * <main>, not a `position: fixed` overlay. Fixed, it floated over whatever
 * the page had at that height on first paint (the home card's button in zh,
 * the /apply/status Continue button), and bottom padding in <main> only helps
 * once the page is scrolled to its end. In the column it takes its own height
 * whatever the language, so the page above always ends where the links begin.
 */
import { useTranslation } from 'react-i18next';

export function LegalStrip() {
  const { t } = useTranslation('shell');
  return (
    <div
      className="hidden md:flex flex-shrink-0 justify-center pb-2"
      aria-label={t('legal.landmark')}
    >
      <nav className="flex flex-wrap items-center gap-x-2 gap-y-0.5 rounded-full border border-stevens-rule-2/60 bg-stevens-bg/85 px-3 py-1 text-meta text-stevens-ink-3 backdrop-blur-sm">
        <a href="/privacy" className="hover:text-foreground transition-colors">{t('legal.privacy')}</a>
        <span aria-hidden>·</span>
        <a href="/terms" className="hover:text-foreground transition-colors">{t('legal.terms')}</a>
        <span aria-hidden>·</span>
        <a href="/sms-terms" className="hover:text-foreground transition-colors">{t('legal.sms')}</a>
        <span aria-hidden>·</span>
        <a href="/legal/cookies" className="hover:text-foreground transition-colors">{t('legal.cookies')}</a>
        <span aria-hidden>·</span>
        <a href="/legal" className="hover:text-foreground transition-colors">{t('legal.all')}</a>
      </nav>
    </div>
  );
}
